import ProductPresentation from '@/components/product/ProductPresentation';
import { Box } from '@mui/system';
import { useParams, useRouteLoaderData } from 'react-router-dom';

export default function App() {
  const { name } = useParams();
  const { apps, deployments } = useRouteLoaderData('auth');
  const app = apps.find(
    (a) => a.name === name || a.title === name || a._id === name,
  );
  let appDeployments = [];
  if (app) {
    appDeployments = deployments.filter((d) => d.app === app._id);
  }

  if (!app || !app.heading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
          px: 2,
          textAlign: 'center',
        }}
      >
        <Box sx={{ width: '70%' }}>
          Die Landing-Page für diese App befindet sich aktuell in der
          Entwicklung. Wir bitten Sie, noch ein wenig Geduld zu haben. Gerne
          können Sie uns bei Fragen telefonisch oder per Mail kontaktieren!
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        px: 2,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <ProductPresentation
        product={app}
        app={app}
        deployments={appDeployments}
        // onDeploy={() => setInstallationActive(true)}
        // onCreateNew={() => setInstallationActive(true)}
      />
    </Box>
  );
}
